<template lang="pug">
div.score-box
	.cap-rating(v-if="isCaps" onclick="void(0)" :style="`background-image: url('${$store.state.config.s3ResourceHost}/images/cap-ratings/rating-caps-${score}.svg')`" :class="`${score}`")
	.star-img(v-if="!isCaps && score != null && showStars")
		b-img-lazy(:src="`//web-resources.savingforcollege.com/images/${score}-Star.svg`" :alt="`${score} of 5`" fluid)

	div(v-if="showCount" :class="{'no-stars': !showStars}")
		div(v-if="isCaps")
			.count(v-if="score != 'NP' && score != 'NO' && score != 'FDIC'") {{score.replace("A","")}} {{ this.$t("of") }} 5
		div(v-else)
			.count(v-if="score") {{score}} {{ this.$t("of") }} 5
			.count(v-else) N/A

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.cap-rating
		background-position: left center
		&.4A
		&.5A
		&.3A
			height: 30px
		&.NO
			background-image: url("https://web-resources.savingforcollege.com/images/cap-ratings/rating-caps-NO.svg") !important
			height: 30px
		&.NP
			background-image: url("https://web-resources.savingforcollege.com/images/cap-ratings/rating-caps-NP.svg") !important
			height: 30px
		&.FDIC
			background-image: url("https://web-resources.savingforcollege.com/images/cap-ratings/rating-caps-FDIC.svg") !important
			height: 36px
			width: 125px


	.cap-rating
	.star-img
		display: block
		height: 21px
		width: 115px
		margin-top: 5px
		max-width: 90%
		padding: 0
		margin: 0
		img
			position: relative
			top: -3px

	.count
		text-align: left

	.count
		font-size: body-font-size-md
		font-weight: body-font-weight
		padding-top: 10px
	@media (max-width: 768px)
		.count
			padding-bottom: 15px

	.no-stars
		.count
			padding-top: 0px

</style>
<script>
export default {
	props: {
		showCount:{
			type: Boolean,
			default: true
		},
		showStars:{
			type: Boolean,
			default: true
		},
		score:{
			default: '0'
		},
		isCaps :{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
		}
	}
}
</script>
